import { format } from "date-fns";
import { Message as ChatMessageType } from "./types";
import { cn } from "@/lib/utils";
import React from 'react';

interface ChatMessageProps {
	message: ChatMessageType;
	onEntityClick?: (e: React.MouseEvent) => void;
}

export const ChatMessage = ({ message, onEntityClick }: ChatMessageProps) => {
	const isUser = message.role === "user";
	const timestamp = message.timestamp instanceof Date ? message.timestamp : new Date(message.timestamp);

	const handleClick = (e: React.MouseEvent) => {
		if (onEntityClick) {
			onEntityClick(e);
		}
	};

	return (
		<div className={cn("group flex w-full items-start gap-2 animate-fade-in", isUser ? "justify-end" : "justify-start")}>
			{!isUser && (
				<div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-sm bg-gradient-to-br from-blue-500 to-blue-600 shadow-sm">
					<img src="/img/NewDiggerIcon.png" alt="" className="h-4 w-4 brightness-0 invert" />
				</div>
			)}
			<div className={cn("flex max-w-[85%] flex-col", isUser ? "items-end" : "items-start")}>
				<div
					className={cn(
						"rounded-sm px-3 py-2 text-sm leading-relaxed shadow-sm",
						isUser
							? "rounded-br-none bg-gradient-to-br from-blue-500 to-blue-600 text-white"
							: "rounded-bl-none border border-border bg-white/80 text-foreground backdrop-blur-md dark:bg-gray-800/80"
					)}
					onClick={handleClick}
				>
					<p className="whitespace-pre-wrap break-words">
						{Array.isArray(message.content)
							? message.content.map((part, idx) =>
								typeof part === 'string'
									? part
									: React.createElement(part.type, { key: idx, ...part.props })
							)
						: message.content}
					</p>
				</div>
				<span className="mt-1 text-[10px] text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100">
					{format(timestamp, "HH:mm")}
				</span>
			</div>
		</div>
	);
};
